import { types } from 'mobx-state-tree'

import storeWithFlags from '../../../utils/storeWithFlags'

const store = types
	.model({
		msgInputValue: types.maybe(types.string)
	})
	.actions(self => ({
		setMsgInputValue(msgInputValue: any) {
			self.msgInputValue = msgInputValue
		}
	}))

export default types
	.compose(
		storeWithFlags,
		store
	)
	.create({})